import { ComponentType } from '../types';
import { AbstractComponentBuilder } from './AbstractComponentBuilder';
export class FacesRatingBarComponentBuilder extends AbstractComponentBuilder {
    constructor(id) {
        super(id, ComponentType.FacesRatingBar);
    }
    setTooltips(tooltips) {
        this.patch({
            tooltips,
        });
        return this;
    }
    isValid() {
        const { tooltips } = this.state();
        const validation = this.createValidationResponse().withParentValidation(super.isValid());
        if (tooltips?.length) {
            validation.withCheck('should be exactly 5 tooltips', () => {
                return tooltips?.length === 5;
            });
        }
        return validation.validate();
    }
}
//# sourceMappingURL=FacesRatingBarComponentBuilder.js.map